module.exports = __webpack_public_path__ + "img/18.d0fcb434.png";